/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Divider, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReportService from "../../services/reportService";
import { formatPrice } from "../../utils";
import PdfRemainingReport from "../../components/prints/report/pdfRemainingReport";
import React from "react";
import { AuthContext } from "../../provider/authProvider";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import BranchDropdown from "../../components/dropdowns/branchDropdown";

const RemainingsReport = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const { user } = useContext(AuthContext);
    const userPermissions = user?.permissions || [];
    const allBranchPermission = userPermissions?.some(p => p.value === 'allBranches');
    const [selectedBranch, setSelectedBranch] = useState(null);

    const [report, setReport] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const fetchReport = async () => {
        if (isLoading) return;
        setIsLoading(true);
        try {
            const filters = {
                branchId: selectedBranch?.id,
            };

            const data = await ReportService.fetchRemaining(filters);
            setReport(data);

        } catch (error) {
            console.error('Error fetching report:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const resetFilter = () => {
        setSelectedBranch(null);
    };


    useEffect(() => {
        fetchReport();
    }, [selectedBranch]);

    return (
        <Box sx={{
            p: isTablet ? 1 : 4,
            backgroundColor: theme.palette.secondary.main
        }}>

            {/* Filter row */}
            {
                allBranchPermission && <Box
                    sx={{
                        mb: 2,
                        display: 'flex',
                        alignItems: 'center',
                        border: 1,
                        borderColor: theme.palette.customGrey.borderInput,
                        backgroundColor: 'white',
                        borderRadius: 1,
                        height: 60,
                        width: isTablet ? '100%' : '45%'
                    }}
                >
                    <Box sx={{ px: 2 }}>
                        <FilterAltOutlinedIcon />
                    </Box>
                    <Divider orientation="vertical" />
                    <Box width={isTablet ? '60%' : '50%'}>
                        <BranchDropdown
                            isFilter={true}
                            selectedBranch={selectedBranch}
                            setSelectedBranch={setSelectedBranch}
                        />
                    </Box>

                    <Divider orientation="vertical" />
                    <Box
                        sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            color: theme.palette.text.red,
                            px: 2,
                            cursor: 'pointer',
                        }}
                        onClick={resetFilter}
                    >
                        <ReplayOutlinedIcon />
                        <Box width={3}></Box>
                        <Typography variant="subtitle2">{t('resetFilter')}</Typography>
                    </Box>
                </Box>
            }

            <Box
                sx={{
                    display: 'flex',
                    // justifyContent: 'center'
                }}>
                <Box
                    sx={{
                        width: isTablet ? '100%' : '80%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        border: 1,
                        borderColor: theme.palette.customGrey.borderInput,
                        py: 4,
                        px: isTablet ? 1 : 4,
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        mb: isTablet ? 0 : 6
                    }}>
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            {t('totalRemainingsSheet')}
                        </Typography>
                    </Box>

                    <Box my={6} sx={{
                        display: isTablet ? 'flex' : 'unset'
                    }}>
                        <Divider sx={{ mt: 2 }} />

                        {/* title */}
                        <Box
                            sx={{
                                display: isTablet ? 'unset' : 'flex',
                                width: isTablet ? '30%' : '100%',
                                justifyContent: 'space-between'
                            }}>
                            <Box
                                sx={{
                                    width: isTablet ? '100%' : '33.3%',
                                    borderRight: 1,
                                    borderLeft: 1,
                                    borderTop: isTablet ? 1 : 0,
                                    borderBottom: isTablet ? 1 : 0,
                                    borderColor: theme.palette.customGrey.borderInput,
                                    px: 1,
                                    py: 2,
                                    bgcolor: theme.palette.customGrey.insideInput,
                                    height: isTablet ? 120 : null
                                }}>
                                <Typography id="transition-modal-title" variant="body1" fontWeight='bold'>
                                    {t('driver')}
                                </Typography>
                            </Box>

                            <Box sx={{
                                width: isTablet ? '100%' : '33.3%',
                                borderRight: 1,
                                borderLeft: 1,
                                borderTop: isTablet ? 1 : 0,
                                borderBottom: isTablet ? 1 : 0,
                                borderColor: theme.palette.customGrey.borderInput,
                                px: 1,
                                py: 2,
                                bgcolor: theme.palette.customGrey.insideInput,
                                height: isTablet ? 120 : null
                            }}>
                                <Typography id="transition-modal-title" variant="body1" fontWeight='bold'>
                                    {t('office')}
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    width: isTablet ? '100%' : '33.3%',
                                    borderRight: 1,
                                    borderLeft: 1,
                                    borderTop: isTablet ? 1 : 0,
                                    borderBottom: isTablet ? 1 : 0,
                                    borderColor: theme.palette.customGrey.borderInput,
                                    px: 1,
                                    py: 2,
                                    bgcolor: theme.palette.customGrey.insideInput,
                                    height: isTablet ? 120 : null
                                }}>
                                <Typography id="transition-modal-title" variant="body1" fontWeight='bold'>
                                    {t('page')}
                                </Typography>
                            </Box>

                        </Box>
                        <Divider />

                        {/* body */}
                        <Box
                            sx={{
                                display: isTablet ? 'unset' : 'flex',
                                width: isTablet ? '70%' : '100%',
                                justifyContent: 'space-between'
                            }}>
                            <Box
                                sx={{
                                    width: isTablet ? '100%' : '33.3%',
                                    borderRight: 1,
                                    borderLeft: 1,
                                    borderTop: isTablet ? 1 : 0,
                                    borderBottom: isTablet ? 1 : 0,
                                    borderColor: theme.palette.customGrey.borderInput,
                                    px: 1,
                                    py: 2,
                                    height: isTablet ? 120 : null
                                }}>
                                <Typography id="transition-modal-title" variant="body1">
                                    {t('remaining')} : {formatPrice(report.driver?.totalRemainingAmount)}
                                </Typography>

                                <Typography id="transition-modal-title" variant="body1" mt={2}>
                                    {t('posts')} : {formatPrice(report.driver?.totalPosts)}
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    width: isTablet ? '100%' : '33.3%',
                                    borderRight: 1,
                                    borderLeft: 1,
                                    borderTop: isTablet ? 1 : 0,
                                    borderBottom: isTablet ? 1 : 0,
                                    borderColor: theme.palette.customGrey.borderInput,
                                    px: 1,
                                    py: 2,
                                    height: isTablet ? 120 : null
                                }}>
                                <Typography id="transition-modal-title" variant="body1">
                                    {t('remaining')} : {formatPrice(report.post?.totalRemainingAmount)}
                                </Typography>

                                <Typography id="transition-modal-title" variant="body1" mt={2}>
                                    {t('posts')} : {formatPrice(report.post?.totalPosts)}
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    width: isTablet ? '100%' : '33.3%',
                                    borderRight: 1,
                                    borderLeft: 1,
                                    borderTop: isTablet ? 1 : 0,
                                    borderBottom: isTablet ? 1 : 0,
                                    borderColor: theme.palette.customGrey.borderInput,
                                    px: 1,
                                    py: 2,
                                    height: isTablet ? 120 : null
                                }}>
                                <Typography id="transition-modal-title" variant="body1">
                                    {t('remaining')} : {formatPrice(report.page?.totalRemainingAmount)}
                                </Typography>

                                <Typography id="transition-modal-title" variant="body1" mt={2}>
                                    {t('posts')} : {formatPrice(report.page?.totalPosts)}
                                </Typography>
                            </Box>


                        </Box>
                        <Divider />

                    </Box>


                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: '100%',
                            mt: isTablet ? 0 : 6
                        }}
                    >
                        <PdfRemainingReport
                            data={{
                                branch: selectedBranch,
                            }} />
                    </Box>
                </Box>
            </Box>

        </Box>
    );
}

export default RemainingsReport;